import { useEffect } from 'react';
import { useQuery } from '@tanstack/react-query';
import { api } from '../api/client';
import { tenantSlugFromHost } from '../lib/tenant-host';

interface TenantBrief {
  id: number;
  name: string;
  slug: string;
  logo: string | null;
}

/**
 * 按当前访问域名识别租户，返回租户名并同步浏览器标签标题。
 *
 * 用 public 接口 /auth/tenants（无需登录），登录页与登录后都可用，
 * 避免把单一客户名（如「瑞小美」）硬编码到标题/侧边栏。
 */
export function useTenantBrand() {
  const slug = tenantSlugFromHost(window.location.hostname);
  const { data } = useQuery({
    queryKey: ['auth-tenants'],
    queryFn: () => api.get<unknown, TenantBrief[]>('/auth/tenants'),
    staleTime: 5 * 60_000,
  });
  const tenant = slug ? data?.find((t) => t.slug === slug) : undefined;
  const tenantName = tenant?.name ?? '';
  const brandTitle = tenantName ? `${tenantName}人才盘点` : '人才盘点系统';

  useEffect(() => {
    document.title = brandTitle;
  }, [brandTitle]);

  return { tenantName, brandTitle };
}
